import { Action } from '@ngrx/store';
import { DashboardInformation } from 'app/dashboardInformation/store/dashboard-information.model';


export const Add_DashboardInformation = '[Chat] Add DashboardInformation';


export class AddDashboardInformation implements Action {
    readonly type = Add_DashboardInformation;

    constructor(public payload: DashboardInformation ) {}
}


export type DashboardInformationActions =
| AddDashboardInformation;
